import { render, staticRenderFns } from "./certificateIndex.vue?vue&type=template&id=fa99d88e&scoped=true&"
import script from "./certificateIndex.vue?vue&type=script&lang=js&"
export * from "./certificateIndex.vue?vue&type=script&lang=js&"
import style0 from "./certificateIndex.vue?vue&type=style&index=0&id=fa99d88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa99d88e",
  null
  
)

export default component.exports